var $d8e8c11705c7c81a$exports = {};
$d8e8c11705c7c81a$exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};


export {$d8e8c11705c7c81a$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
